import { render, staticRenderFns } from "./detalles.vue?vue&type=template&id=30526393"
import script from "./detalles.vue?vue&type=script&lang=js"
export * from "./detalles.vue?vue&type=script&lang=js"
import style0 from "./detalles.vue?vue&type=style&index=0&id=30526393&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports